import { Toast } from 'vant';
import HouseholdDialog from '@/components/household_dialog/household_dialog';
import ResidenceDialog from '@/components/residence_dialog/residence_dialog';
import TrafficDialog from '@/components/traffic_dialog/traffic_dialog';
import QrcodeDialig from '@/components/provincial_level/qrcode_dialog/qrcode_dialog';
import WDCS from '@/assets/images/wdcs.svg';
import HNGAIMG from '@/assets/images/hnga.svg'

export default{
    name : 'police_service',
    data () {
        return {
            isShowTraffic: false,
			isShowHousehold: false,
			isShowResidence: false,
            isShowQrcode: false,
            wdcs: WDCS,
            hngaImg: HNGAIMG
        }
    },
    methods: {
		closeTraffic() {
		    this.isShowTraffic = false;
        },
		closeHousehold() {
			this.isShowHousehold = false;
        },
        closeResidence() {
			this.isShowResidence = false;
        },
		zxzx() {
			// window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3dopenid%26redirect%3dpolice.zxzx%26type%3dparams%26params%3dnickName%2copenId&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
            window.location.href = 'https://pay.biutag.com/gate/ad/record/redirect/before?adId=8&sourceType=1&platform=1'
        },
		hzyw() {
            this.isShowHousehold = true;
        },
        wfcx() {
			this.$router.push('/violation_inquiry');
		},
        yqdj() {
            // window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3duserid%26redirect%3dpolice.yqdj%26type%3dnone&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
            window.location.href = 'https://pay.biutag.com/gate/ad/record/redirect/before?adId=8&sourceType=2&platform=1'
        },
        jjyw() {
		    //this.isShowTraffic = true;
            this.$router.push('/ga_fwpt');
        },
		wsyy() {
            this.$router.push('/ga_fwpt');
			//window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3dopenid%26redirect%3dpolice.wsyy%26type%3dnone&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
        },
		sqmj() {
			this.$router.push('/police');
        },
        jzzyw() {
        	//this.isShowResidence = true;
            window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3duserid%26redirect%3dpolice.jzz%26type%3dnone&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
        },
		spbj() {
			this.$router.push('/video_alarm');
		},
        nbyw() {
            window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3dopenid%26redirect%3dpolice.nbyw%26type%3dnone&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect"
        },
        kczp() {
            window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3dopenid%26redirect%3dpolice.kczp%26type%3dparams%26params%3dopenId&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
        },
        wfjk() {
            window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3duserid%26redirect%3dpolice.wfjk%26type%3dnone&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
        },
        ychj() {
            window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3duserid%26redirect%3dpolice.ychj%26type%3dparams%26params%3dopenId&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
        },
        wfzjlzm() {
            // window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3duserid%26redirect%3dservice.wfzzm%26type%3dparams%26params%3dopenId&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
            window.location.href = 'https://pay.biutag.com/gate/ad/record/redirect/before?adId=8&sourceType=3&platform=1'
        },
        unable() {
            Toast('功能建设中，敬请期待');
        },
        hnga() {
            // window.location.href = 'https://fwpt.hnga.gov.cn/weixin'
            window.location.href = 'https://pay.biutag.com/gate/ad/record/redirect/before?adId=8&sourceType=4&platform=1'
        },
        openWdcs() {
		    this.isShowQrcode = true;
        }
    },
	components: {
        'TrafficDialog':TrafficDialog,
		'HouseholdDialog':HouseholdDialog,
		'ResidenceDialog':ResidenceDialog,
        'QrcodeDialig': QrcodeDialig
	}
}


// WEBPACK FOOTER //
// ./src/components/police_service/police_service.controller.js